import axios from 'axios'
import { Message } from 'element-ui'
import router from '@/router'
import store from '@/store'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 30000
})

service.interceptors.request.use((config) => {
  const token = store.state.user.token
  if (token) {
    // 与 songqixia-backend AuthFilter 一致：整段 JWT 放在 Authorization
    config.headers.Authorization = token
  }
  config.headers['Content-Type'] = 'application/json'
  return config
})

service.interceptors.response.use(
  async (response) => {
    if (response.config.responseType === 'blob') {
      const blob = response.data
      if (blob && blob.type && blob.type.includes('application/json')) {
        try {
          const text = await blob.text()
          const json = JSON.parse(text)
          if (json.code !== 0) {
            Message.error(json.message || '导出失败')
            return Promise.reject(new Error(json.message || '导出失败'))
          }
        } catch (e) {
          Message.error('导出失败')
          return Promise.reject(e)
        }
      }
      return response
    }
    const body = response.data
    if (body && typeof body.code === 'number' && body.code !== 0) {
      Message.error(body.message || '请求失败')
      return Promise.reject(new Error(body.message || '请求失败'))
    }
    return body
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      store.dispatch('user/logout')
      router.push({ path: '/login', query: { redirect: router.currentRoute.fullPath } })
      Message.warning('登录已过期，请重新登录')
    } else {
      Message.error((error.response && error.response.data && error.response.data.message) || error.message || '网络异常')
    }
    return Promise.reject(error)
  }
)

export default service
